module.exports = __webpack_public_path__ + "img/P150T_weapon_63.8c313c2c.png";